import { render, staticRenderFns } from "./WenBrigade.vue?vue&type=template&id=15c55a37&scoped=true&"
import script from "./WenBrigade.vue?vue&type=script&lang=js&"
export * from "./WenBrigade.vue?vue&type=script&lang=js&"
import style0 from "./WenBrigade.vue?vue&type=style&index=0&id=15c55a37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c55a37",
  null
  
)

export default component.exports